import React, {useState} from "react";
import { Provider, Root, Viewport } from "@radix-ui/react-toast";
import Progress from "../ui/progress";
import pdfEx from '../../assets/icons/pdf-ex.svg';

export const stateNames = {
    success: "success",
    error: "error",
    isLoading: "isLoading"
}
const toastState = {
    success: {
        statusTextStyle: "text-green-500",
        statusText: "Completed",
        getContext: (linkAction) => {
            return <>If your download hasn’t started, <span
                onClick={linkAction}
                className="text-[#3B82F6] hover:text-blue-800 cursor-pointer">
                    click here
                </span>
            </>
        }
    },
    error: {
        statusTextStyle: "text-red-500",
        statusText: "Error",
        getContext: (linkAction) => {
            return <>Download failed. <span
                onClick={linkAction}
                className="text-[#3B82F6] hover:text-blue-800 cursor-pointer">
                    Try again.
                </span>
            </>
        }
    },
    isLoading: {
        statusTextStyle: "text-neutral-500",
        statusText: "Downloading",
        getContext: () => <></>
    }
}

const ToastDownload = ({duration, stateName, title = "New Evaluation", linkAction}) => {
    const [open, setOpen] = useState(true);

    return (
        <Root
            className="grid grid-cols-[auto_max-content] items-center gap-x-[8px] rounded-md bg-white p-[8px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] [grid-template-areas:_'title_action'_'description_action'] data-[swipe=cancel]:translate-x-0 data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[state=closed]:animate-hide data-[state=open]:animate-slideIn data-[swipe=end]:animate-swipeOut data-[swipe=cancel]:transition-[transform_200ms_ease-out]"
            open={open}
            onOpenChange={setOpen}
            duration={duration || 999999}
        >
            <div className="flex">
                <img src={pdfEx} alt="alert" className="h-10 w-10"/>
                <div className="pl-2 w-full">
                    <div
                        className="font-medium text-[14px] leading-[14px] align-middle tracking-normal flex justify-between w-full pt-1">
                        <span>{title}</span>
                        <span className={`font-normal ${toastState[stateName].statusTextStyle}`}>
                                {toastState[stateName].statusText}
                            </span>
                    </div>

                    <div className="leading-[20px]">
                            <span
                                className="text-gray-500 font-normal text-[10px] leading-[10px] tracking-normal text-right align-middle">
                                {
                                    stateName === stateNames.isLoading ?
                                        <div className="h-[16px] flex flex-col justify-end">
                                            <Progress/>
                                        </div> :
                                        toastState[stateName].getContext(linkAction)
                                }

                            </span>
                    </div>
                </div>
            </div>
        </Root>
    );
};

export const ToastProvider = ({children}) => {
    return <Provider>
        <Viewport
            className="fixed top-0 right-0 z-[2147483647] m-0 flex w-[390px] max-w-[100vw] list-none flex-col gap-2.5 p-[var(--viewport-padding)] outline-none [--viewport-padding:_25px]"
        />
        {children}
    </Provider>
}

export default ToastDownload;
